/**
 * Bring a marked element into view, centred: the phone's docked keypads use
 * it so the value being typed sits above the pad, and the record wizard's
 * blocker list uses it to jump to a card. A no-op where layout does not exist
 * (a test DOM without `scrollIntoView`).
 */

/** A CSS attribute-selector value: quotes and backslashes escaped. */
export function attributeValue(value: string): string {
  return value.replace(/\\/g, '\\\\').replace(/"/g, '\\"')
}

/** Find `selector` inside `root` (the document by default) and scroll it to the centre. */
export function scrollToMarked(root: ParentNode | null, selector: string): void {
  const element = root?.querySelector<HTMLElement>(selector)
  if (element && typeof element.scrollIntoView === 'function') {
    element.scrollIntoView({ block: 'center', behavior: 'smooth' })
  }
}
